/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { usageGetMeterUsage } from "../funcs/usageGetMeterUsage.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { MeterUsageResponse } from "../models/components/meterusageresponse.js";
import {
  Family,
  GetMeterUsageRequest,
  GetMeterUsageSecurity,
} from "../models/operations/getmeterusage.js";
import { unwrapAsync } from "../types/fp.js";
export type GetMeterUsageQueryData = MeterUsageResponse;

export function prefetchGetMeterUsage(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetMeterUsageRequest,
  security?: GetMeterUsageSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetMeterUsageQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetMeterUsageQuery(
  client$: GramCore,
  request: GetMeterUsageRequest,
  security?: GetMeterUsageSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<GetMeterUsageQueryData>;
} {
  return {
    queryKey: queryKeyGetMeterUsage({
      family: request.family,
      from: request.from,
      to: request.to,
      breakdown: request.breakdown,
      gramSession: request.gramSession,
    }),
    queryFn: async function getMeterUsageQueryFn(
      ctx,
    ): Promise<GetMeterUsageQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(usageGetMeterUsage(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetMeterUsage(
  parameters: {
    family: Family;
    from?: Date | undefined;
    to?: Date | undefined;
    breakdown?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "usage", "getMeterUsage", parameters];
}
